export const splitLanguage: (lang: string) => string = (lang) =>
  lang.split("-")[0];
